export default __webpack_public_path__ + "assets/profeature-grid-fixed-old.200a0dd097489d4dd86221cdcb64b325.jpg";